import { genRanId, secsToMs } from '@helpers/utils.js'
import i18n from '@plugins/localisation.js'
import { TOAST_SECONDS } from '@config'
import { readonly, ref } from 'vue'

const queue = ref([])
// {
//   title: 'toast title',
//   text: 'toast text',
//   isError: true,
//   hasClose: false,
// }

export const activeToasts = readonly(queue)

export function addToast(
  {
    title,
    text,
    isSuccess,
    isInfo,
    isWarning,
    isError,
    hasClose,
    errorRef,
    animate = true,
    timeout = TOAST_SECONDS,
  } = {},
  name = genRanId()
) {
  const toast = {
    name,
    title,
    text,
    isSuccess,
    isInfo,
    isWarning,
    isError,
    hasClose,
    errorRef,
    animate,
    timeout,
  }

  queue.value.push(toast)

  if (!hasClose) {
    setTimeout(() => {
      closeToast(name)
    }, secsToMs(timeout))
  }
}

export function defaultErrorToast() {
  const t = i18n.global.t
  addToast({
    title: t('error'),
    text: t('default_error_message'),
    isError: true,
  })
}

export function closeToast(name) {
  queue.value = queue.value.filter((q) => q.name !== name)
}
